<template>
	<div>
		<a @click.prevent="openPopup()" href="#" :class="['flex items-start pt-1.5 pb-2',kebabCase(itemName)+'-button'].join(' ')">
			<div>
				<h6 class="mt-2 uppercase pl-2">{{ itemName }}</h6>
			</div>
			<svg class="ml-auto mt-3 transform rotate-0" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M2.18538 4.99338L-5.34058e-05 -4.26112e-07L9.74829 4.99338L-5.38429e-05 10L2.18538 4.99338Z" fill="#000000"/>
			</svg>
		</a>
			<div v-if="active"
					 class="fixed z-200 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
				<div class="flex items-center px-6 justify-center min-h-screen text-center sm:block w-full sm:p-0">
					<div @click="close" class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
					<span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
					<div class="inline-block w-full relative align-bottom bg-white text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
						<div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
							<div class="sm:flex sm:items-start ">
								<div @click="close"  class="modal-close absolute top-3 left-3 cursor-pointer z-50">
									<svg class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
										<path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
									</svg>
								</div>
								<div class="mt-3 text-center pb-10 pt-10 w-full">
									<h5 class="mb-6 text-hamlet-red">Download {{ itemName }}</h5>
									<div class="form">
										<slot>
										</slot>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
	</div>
</template>

<script>
import { kebabCase } from "lodash";
export default {
	name: "popup",
	props: {
		itemName: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			active: false
		}
	},
	methods: {
		openPopup(){
			this.active = true;
		},
		close(){
			this.active = false;
		},
		kebabCase (str) {
			return kebabCase(str);
		}
	},
	watch: {
		active(value){
			document.querySelector('body').classList.toggle('overflow-y-hidden');
		}
	}
}
</script>

<style scoped>

</style>
